<template>
  <iframe
    :src="url"
    style="display: block"
    frameborder="0"
    height="100%"
    width="100%"
  />
</template>

<script>
export default {
  data() {
    return { url: '' };
  },

  created() {
    this.url = this.$route.query.url;
  },
};
</script>
